import React from 'react';
import { Route, Redirect, Switch } from 'react-router-dom';
import ImagePopupContainer from 'containers/util/ImagePopupContainer';
import { pageUrl } from 'lib/mapper';
import { useLocation } from 'react-router';
import { useShallowAppSelector } from 'store/hooks';

function Util() {
  const { isFullScreen } = useShallowAppSelector(state => ({
    isFullScreen: state.file.isFullScreen,
  }));
  const { pathname } = useLocation();

  return (
    <Switch>
      <Redirect exact path={pageUrl.Util.index} to={pageUrl.Util.imgPopup} />
      <Route path={pageUrl.Util.imgPopup} component={ImagePopupContainer} />
      <Route component={() => <Redirect to={pageUrl.error.notFound} />} />
    </Switch>
  );
}

export default Util;
